import working_png from "../../assets/working.png";

function AuthRight({
  title = "Welcome Back to MyWorkApp!",
  subTitle = "Please login to your account to access all of your information.",
}) {
  return (
    <div
      className="relative flex w-1/2 shrink-0 flex-col items-center justify-center gap-10"
      style={{
        background: "linear-gradient(180deg, #194A6D 0%, #032136 100%)",
      }}
    >
      <div className="z-10 mx-20 flex flex-col items-start justify-center gap-10 text-center font-semibold text-white">
        {/* <p className="m-0 text-6xl">{title}</p>
        <p className="m-0 text-2xl">{subTitle}</p> */}
        <div className="flex items-center gap-5">
          <div className="flex flex-col items-center gap-5 space-x-3">
            <img src={working_png} alt="MyWorkApp" className="h-60 w-60" />
            {/* <span className="hidden text-4xl font-bold text-white sm:inline-block">
              MyWorkApp.io
            </span> */}
          </div>
        </div>
      </div>
      <div className="bg-auth-mask-group absolute bottom-0 left-0 h-1/2 w-1/2 rotate-180 bg-cover"></div>
      <div className="bg-auth-mask-group absolute right-0 top-0 h-1/2 w-1/2 bg-cover"></div>
    </div>
  );
}

export default AuthRight;
